import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from './Redux/languageSlice';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LanguageIcon from '@mui/icons-material/Language';
import i18next from 'i18next';
import { postApi } from './api/services';
import { serviceDown } from './utils/UtilityFunctions';
import TranslateIcon from '@mui/icons-material/Translate';
import { Input, InputAdornment, OutlinedInput } from '@mui/material';

const LanguageSelector = ({from}) => {
  const dispatch = useDispatch();
  const locale = useSelector((state) => state.language.langData);

  const handleLanguageChange = (event) => {
    const newLocale = event.target.value;
    dispatch(setLanguage(newLocale));
    i18next.changeLanguage(newLocale);
    if(!from){
        updateLang(newLocale)
    }
  };

  const updateLang = (loc) => {
    let params = {
        user_id: localStorage.getItem("user_id"),
        preferred_language: loc
    }
    postApi("update_preferred_language", params)
        .then((res) => {
            console.log("language updated successfully");   
        })
        .catch((err) => {
            console.log("err", err);
            serviceDown()  
        })
  }

  return (
    <div>
        <Select
            variant="standard"
            value={locale}
            onChange={handleLanguageChange}
            className="language-select"
            disableUnderline
            input={
                <Input
                    startAdornment={
                    <InputAdornment>
                        <TranslateIcon/>
                    </InputAdornment>
                    }
                />
                }
                    >
                    <MenuItem value="en">
                            <div className='d-flex justify-content-start align-items-center'>
                                <div className='d-flex justify-content-center align-items-center w-100 languages'>
                                    English

                                </div>

                            </div>
                    </MenuItem>
                    <MenuItem value="es">
                            <div className='d-flex justify-content-start align-items-center'>
                                <div className='d-flex justify-content-center align-items-center w-100 languages'>
                                    Español

                                </div>

                            </div>
                    </MenuItem>
                    <MenuItem value="fr">
                            <div className='d-flex justify-content-start align-items-center'>
                                <div className='d-flex justify-content-center align-items-center w-100 languages'>
                                    Français

                                </div>

                            </div>
                    </MenuItem>
                    <MenuItem value="ger">
                            <div className='d-flex justify-content-start align-items-center'>
                                <div className='d-flex justify-content-center align-items-center w-100 languages'>
                                    Deutsch
                                </div>
                            </div>
                    </MenuItem>
        </Select>
    </div>
  );
};

export default LanguageSelector;